/**
 * Mocked weekly availability heat-map for the Squadrons explore page
 * "see when your members can play" block.
 *
 * Shape: 7 days × 8 evening hour-bands (16:00–24:00) — covers the
 * common gaming window without sprawling into 24×7. Each cell is the
 * count of mocked members available in that band. Values picked to
 * land a recognisable pattern: heavy weekday evenings 19:00–22:00,
 * even heavier weekends.
 */

export const HOUR_BANDS = [
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '23',
] as const

export const DAY_LABELS = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'] as const

// Row = day, col = hour band. Values are count of available members
// (0–20 since the mock roster is 20). Tuned for plausibility:
// weeknights peak 20:00–22:00; weekends start earlier; Sun winds down
// 22:00+.
export const AVAILABILITY_HEATMAP: number[][] = [
  // MON
  [2, 4, 6, 11, 14, 13, 9, 4],
  // TUE
  [1, 3, 5, 10, 15, 14, 11, 5],
  // WED
  [2, 3, 6, 12, 16, 14, 10, 4],
  // THU
  [2, 4, 6, 11, 14, 13, 9, 3],
  // FRI
  [4, 6, 9, 13, 16, 15, 12, 7],
  // SAT
  [6, 8, 11, 14, 17, 16, 13, 9],
  // SUN
  [5, 8, 12, 15, 16, 14, 9, 4],
]

/** Aggregate availability for the "peak window" tile. */
export const PEAK_WINDOW_LABEL = 'Sat 20:00 — 17 of 47 available'
export const TOP_GAME_LABEL = 'Counter-Strike 2 — 23 members enrolled'
